import React, { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { X, Mail, HelpCircle } from "lucide-react";

const FAQ_AR = [
  { q: "كم تستغرق الورقة؟", a: "خلال دقائق. يمكنك إغلاق المتصفح؛ سنحفظ النتيجة في طلباتي." },
  { q: "هل المراجع حقيقية؟", a: "نعم — كل مرجع يُتحقَّق منه عبر Crossref قبل التسليم. لا اختلاق." },
  { q: "هل أستطيع تعديل الورقة؟", a: "نعم — تُسلَّم بصيغة Word (.docx) قابلة للتعديل بالكامل." },
  { q: "لماذا لا أحصل على استرداد بعد الإنجاز؟", a: "المخرجات رقمية تُسلَّم فور إنجازها؛ هذا متّفقٌ عليه عند تأكيد الطلب." },
];
const FAQ_EN = [
  { q: "How long does it take?", a: "Within minutes. You can close the browser — we save the result to your archive." },
  { q: "Are the references real?", a: "Yes — every citation is verified against Crossref before delivery. No hallucinations." },
  { q: "Can I edit the paper?", a: "Yes — delivered as a fully editable Word (.docx) file." },
  { q: "Why no refund after completion?", a: "Digital outputs delivered instantly; this is acknowledged at order confirmation." },
];

export default function SupportWidget() {
  const { lang } = useLanguage();
  const [open, setOpen] = useState(false);
  const faqs = lang === "ar" ? FAQ_AR : FAQ_EN;
  const email = "support@zabatna.com";
  // WhatsApp is intentionally hidden for now — we'll re-enable it once the
  // support number is provisioned. Email-only support keeps the panel clean.
  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-5 end-5 z-50 bg-slate-900 hover:bg-slate-800 text-white rounded-full w-12 h-12 grid place-items-center shadow-lg transition-all"
        data-testid="support-widget-toggle"
        aria-label="Support"
      >
        {open ? <X className="w-5 h-5" /> : <HelpCircle className="w-5 h-5" />}
      </button>
      {open && (
        <div
          className="fixed bottom-20 end-5 z-50 w-[min(360px,calc(100vw-2rem))] bg-white border border-slate-200 rounded-lg shadow-xl p-5"
          data-testid="support-widget-panel"
          dir={lang === "ar" ? "rtl" : "ltr"}
        >
          <h3 className="font-heading text-base font-bold text-slate-900 mb-3 text-start">
            {lang === "ar" ? "الدعم وأسئلة شائعة" : "Support & FAQ"}
          </h3>
          <div className="flex gap-2 mb-4">
            <a
              href={`mailto:${email}`}
              className="flex-1 inline-flex items-center justify-center gap-1.5 bg-slate-100 hover:bg-slate-200 text-slate-900 text-xs py-2 px-3 rounded-md border border-slate-200"
              data-testid="support-email-link"
            >
              <Mail className="w-4 h-4" /> {email}
            </a>
          </div>
          <ul className="space-y-3" data-testid="support-faq">
            {faqs.map((f, i) => (
              <li key={i} className="border-t border-slate-100 pt-2.5">
                <p className="text-xs font-bold text-slate-900 text-start">{f.q}</p>
                <p className="text-xs text-slate-600 leading-relaxed mt-1 text-start">{f.a}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
